import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap} from "rxjs/operators";
import * as fromDistrictGql from "./district.graphql";
import {BaseResponse} from "../../../../../common/interfaces/global-interfaces";
import {GraphqlService} from "../../../../../services/graphql.service";
import {DistrictActions} from "./district.actions";
import {District} from "./district.model";


@Injectable()
export class DistrictEffects {

  loadData$ = createEffect(() => this.actions$.pipe(
    ofType(DistrictActions.getAllDistrictByRegion),
    switchMap((action) => this.apollo.queryObservable({
        query: fromDistrictGql.ALL_DISTRICTS_BY_REGION,
        variables: {regionUniqueId: action.regionUniqueId}
      })
    ),
    switchMap((response: any) => {
      const result: BaseResponse<District[]> = Object.values(Object.values(response)[0])[0];
      if (result?.response?.status) {
        return [
          DistrictActions.loadDistricts({districts: result?.data || []}),
          DistrictActions.districtsLoadingState({loading: false})
        ];
      } else {
        return [DistrictActions.districtsLoadingState({loading: false})];
      }
    })
  ));

  constructor(
    private actions$: Actions,
    private apollo: GraphqlService,
  ) {
  }

}
